import { jsx as _jsx } from "react/jsx-runtime";
import { ListItemText } from "@mui/material";
import { forwardRef } from "react";
export const UiListItemText = forwardRef((props, ref) => _jsx(ListItemText, Object.assign({ ref: ref }, props)));
//# sourceMappingURL=ui_list_item_text.js.map